import {
    Module,
    VuexModule,
    Mutation,
    Action,
} from 'vuex-module-decorators';
import { pullFeatureList, createFeature, updateFeature, pullFeatureDetails, deleteFeature, searchFeature } from '../../services/features'


@Module({
    namespaced: true,
})


export default class Item extends VuexModule {

    // state 
    featureList = [];
    featureDetails = [];
    

    @Action
    public async fetchFeatureList() {
        try {
            const data = await pullFeatureList();
            this.context.commit('setFeatureList', data.response);
            return data.response;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async addFeature(payload) {
        try {
            const data = await createFeature(payload);
            return data.response;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async updateFeature(payload) {
        try {
            const data = await updateFeature(payload.id, payload.data);
            return data.response;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async fetchFeatureDetails(id) {
        try {
            const data = await pullFeatureDetails(id);
            this.context.commit('setFeatureDetails', data.response);
            return data.response;
        } catch (error) {
            throw error
        }
    }

    @Action
    public async deleteFeature(id) {
        try {
            const data = await deleteFeature(id);
            return data.response;
        } catch (error) {
            throw error
        }
    }
    @Action
    public async fetchSearchFeature(payload) {
        try {
            const data = await searchFeature(payload);
            this.context.commit('setFeatureList', data.response);
            return data.response;
        } catch (error) {
            throw error
        }
    }

    // mutations 

    @Mutation
    public setFeatureList(data: any) {
        this.featureList = data;
    }

    @Mutation
    public setFeatureDetails(data: any) {
        this.featureDetails = data;
    }
     // getters
     get GetFeatureList() {
        return this.featureList;
    }
    
     get GetFeatureDetails() {
        return this.featureDetails;
    }

}